const { merge } = require('lodash');

class ResourceInjector {
    constructor($document, $q) {
        this.$document = $document[0];
        this.$q = $q;
    }

    createScript(url, tagParams = null) {
        let script = this.$document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        if (tagParams) {
            script = merge(script, tagParams);
        }
        return script;
    }

    createLink(url, tagParams = null) {
        let link = this.$document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = url;
        if (tagParams) {
            link = merge(link, tagParams);
        }
        return link;
    }

    isScriptInjected(url, element) {
        return !!(element || this.$document.head).querySelector(`[src="${url}"]`);
    }

    isStylesheetInjected(url, element) {
        return !!(element || this.$document.head).querySelector(`[href="${url}"]`);
    }

    injectScript(url, tagParams = null) {
        return this.injectResource(url, this.createScript.bind(this), this.isScriptInjected.bind(this), tagParams);
    }

    injectStylesheet(url, tagParams = null) {
        return this.injectResource(url, this.createLink.bind(this), this.isStylesheetInjected.bind(this), tagParams);
    }

    injectScripts(urls) {
        return this.$q.all(urls.map(this.injectScript.bind(this)));
    }

    injectStylesheets(urls) {
        return this.$q.all(urls.map(this.injectStylesheet.bind(this)));
    }

    injectResource(url, buildAssetFn, isInjectedFn, tagParams = null) {
        const deferred = this.$q.defer();
        if (!isInjectedFn(url)) {
            const assetEl = buildAssetFn(url, tagParams);
            assetEl.onload = deferred.resolve;
            assetEl.onerror = deferred.reject;
            document.head.appendChild(assetEl);
        } else {
            deferred.resolve();
        }

        return deferred.promise;
    }
}

ResourceInjector.$inject = ['$document', '$q'];

module.exports = ResourceInjector;



// WEBPACK FOOTER //
// ./src/olycommon/resources/resource-injector-service.js